<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <header class="card-header">
            <h4 class="pull-right">Добавить категорию</h4>
          </header>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <form autcomplete="off" @submit.prevent="categoryStore()">
                  <div class="form-group">
                    <label>titleRus</label>
                    <input type="text" class="form-control" v-model="category.title" autofocus/>
                  </div>
                  <!-- <div class="form-group">
                    <label>titleUzl</label>
                    <input type="text" class="form-control" v-model="category.titleUzl" />
                  </div>
                  <div class="form-group">
                    <label>titleUzk</label>
                    <input type="text" class="form-control" v-model="category.titleUzk" />
                  </div>
                  <div class="form-group">
                    <label>version</label>
                    <input type="text" class="form-control" v-model="category.version" />
                  </div> -->
                  <div class="form-group">
                    <label>Код</label>
                    <input type="text" class="form-control" v-model="category.code" />
                  </div>
                  <div class="form-group">
                    <label>Выберите категорию</label>
                    <select class="form-control" v-model="category.parent_id">
                      <option value="0">Основная Категория</option>
                      <option
                        v-for="cat in categories"
                        :value="cat.id"
                        :key="cat.id"
                      >{{ cat.title }}</option>
                    </select>
                  </div>
                  <button type="submit" class="btn btn-primary">Добавить</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { GET, FILE } from "../../shared/api";
export default {
  data() {
    return {
      category: {
        parent_id: 0
      },
      categories: []
    };
  },
  methods: {
    getCategories() {
      GET([], "/category", this, false).then(response => {
        this.categories = response;
      });
    },
    categoryStore() {
      let formData = new FormData();
      for (var data in this.category) {
        formData.append(data, this.category[data]);
      }
      FILE(formData, "/category", this).then(response => {
        this.$router.push({ name: "category" });
      });
    }
  },
  created() {
    this.getCategories();
  },
  mounted() {
    	let input = document.querySelector('[autofocus]');
        if (input) {
        	input.focus();
        }
    }
};
</script>
